import validator from "validator";
import authMessage from "../../../../messages/auth";
import mobileValidator from "../../../mobile";
import messages from "./messages";

const validateFirstName = (firstName) => {
  if (validator.isEmpty(firstName)) {
    return authMessage.FIRST_NAME_DOSE_NOT_EXIST;
  }

  if (!firstName.trim().length) {
    return authMessage.FIRST_NAME_DOSE_NOT_EXIST;
  }

  const regexFarsiCharter = /^[\u0600-\u06FF\s]+$/;
  if (!regexFarsiCharter.test(firstName)) {
    return authMessage.FIRST_NAME_DOSE_NOT_FARSI_CHAR;
  }

  return true;
};

const validateIdentityMarketer = (identityMarketer) => {
  if (validator.isEmpty(identityMarketer)) {
    return messages.IDENTITY_MARKETER_DOSE_NOT_EXIST;
  }

  if (!identityMarketer.trim().length) {
    return messages.IDENTITY_MARKETER_DOSE_NOT_EXIST;
  }

  var english = /^[A-Za-z0-9_]*$/;
  if (!english.test(identityMarketer)) {
    return messages.IDENTITY_MARKETER_INVALID;
  }

  return true;
};

const validateMobile = (mobile) => {
  if (validator.isEmpty(mobile)) {
    return authMessage.USER_MOBILE_DOSE_NOT_EXIST;
  }

  if (!mobile.trim().length) {
    return authMessage.USER_MOBILE_DOSE_NOT_EXIST;
  }

  if (!mobileValidator.isNumericMobile(mobile)) {
    return authMessage.USER_MOBILE_WRONG;
  }

  if (!mobileValidator.validMobileNumber(mobile)) {
    return authMessage.USER_MOBILE_WRONG;
  }

  return true;
};

const validatePassword = (password) => {
  if (validator.isEmpty(password)) {
    return authMessage.PASSWORD_DOSE_NOT_EXIST;
  }

  if (!password.trim().length) {
    return authMessage.PASSWORD_DOSE_NOT_EXIST;
  }

  const regexHasNumber = /\d/g;
  if (regexHasNumber.test(password)) {
    var regexHasLetter = /[a-zA-Z]/g;
    if (regexHasLetter.test(password)) {
      return true;
    } else {
      return authMessage.PASSWORD_MUST_HAVE_ONE_LETTER;
    }
  } else {
    return authMessage.PASSWORD_MUST_HAVE_ONE_NUMBER;
  }
};

const validateFormInfoUser = (info) => {
  const resValidateFirstName = validateFirstName(info.first_name);
  if (resValidateFirstName != true) {
    return resValidateFirstName;
  }
  const resValidateMobile = validateMobile(info["mobile"]);
  if (resValidateMobile != true) {
    return resValidateMobile;
  }

  const resValidatePassword = validatePassword(info["password"]);
  if (resValidatePassword != true) {
    return resValidatePassword;
  }

  const identityMarketer = validateIdentityMarketer(info.identity_marketer);
  if (identityMarketer != true) {
    return identityMarketer;
  }

  return true;
};

export default {
  validateFormInfoUser,
};
